module.exports = __webpack_public_path__ + "img/youtube.5891437d.svg";